import React from 'react';

interface HamburgerProps {
  className?: string;
  width?: number;
  height?: number;
}

const HamburgerIcon = function HamburgerIcon({
  className,
  width,
  height,
}: HamburgerProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 30 30"
    >
      <path d="M6.25 8.75H23.75" stroke="#222222" strokeLinecap="round" />
      <path d="M6.25 15H18.75" stroke="#222222" strokeLinecap="round" />
      <path d="M6.25 21.25H13.75" stroke="#222222" strokeLinecap="round" />
    </svg>
  );
};

HamburgerIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default HamburgerIcon;
